module.exports = __webpack_public_path__ + "img/img-header4.b155b9ed.jpg";